import { goldenURL, getMainDomain } from '@golden/url'

export const urlHelper = goldenURL(
  getMainDomain(),
  window.location.protocol as 'https:' | 'http:',
  getMainDomain()
)
